export const formatFullName = (firstName: string, lastName: string) => {
  return `${firstName} ${lastName}`;
};
